// extracted by mini-css-extract-plugin
module.exports = {"form":"Collaborate_form__ZVez8","fields":"Collaborate_fields__3_zWT","shortFields":"Collaborate_shortFields__E7Vkn","messageField":"Collaborate_messageField__1uRqf"};